export default __webpack_public_path__ + "static/media/icons8-discord.65e7396f.svg";